<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Adjust Quantity</h2>
      <div class="modal-subtitle" *ngIf="this.lotInventoryItem.lotNumber">{{"Lot" | tenantWords}} {{this.lotInventoryItem.lotNumber}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faSlidersH" class="section-icon"></fa-icon>
        <h3>Quantity</h3>
      </div>

      <div class="qty-summary">
        <div class="qty-box">
          <span class="qty-label">Current</span>
          <span class="qty-value">{{this.lotInventoryItem.originalQuantity | number:'1.0-2'}}</span>
        </div>
        <div class="qty-box adjusted" [class.up]="this.change > 0" [class.down]="this.change < 0">
          <span class="qty-label">Adjusted</span>
          <span class="qty-value">{{this.lotInventoryItem.quantity | number:'1.0-2'}}</span>
          <span class="qty-change" *ngIf="this.change">{{this.change > 0 ? '+' : ''}}{{this.change | number:'1.0-2'}}</span>
        </div>
      </div>

      <div class="qty-stepper">
        <button mat-stroked-button type="button" aria-label="Subtract amount" (click)="remove()" [disabled]="!this.quantityEdit">
          <fa-icon [icon]="faMinus"></fa-icon>
        </button>
        <mat-form-field appearance="outline">
          <mat-label>Amount to adjust</mat-label>
          <input matInput type="number" min="0" name="qty" [(ngModel)]="this.quantityEdit">
        </mat-form-field>
        <button mat-stroked-button type="button" aria-label="Add amount" (click)="add()" [disabled]="!this.quantityEdit">
          <fa-icon [icon]="faPlus"></fa-icon>
        </button>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faFileLines" class="section-icon"></fa-icon>
        <h3>{{"Reason" | tenantWords}}</h3>
      </div>

      <div class="section-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{"Reason" | tenantWords}}</mat-label>
          <mat-select id="reason" [(ngModel)]="this.lotInventoryItem.reasonCodeId" name="reason" required>
            <mat-option *ngFor="let re of this.reasonCodes" [value]="re.id">
              {{re.reason}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Packout ID</mat-label>
          <input matInput name="packoutCode" [(ngModel)]="this.lotInventoryItem.packoutCode">
        </mat-form-field>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!this.canSave" (click)="submit()">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</div>
